module.exports = __webpack_public_path__ + "./images/03e8ad2c49a3fa13628aa856281406cb.webp";